import MercadoLibre from "@/pixels/providers/mercadolibre";

describe("MercadoLibre", () => {
  let context;

  let ark = {
    src: "",
    width: "",
    height: ""
  };

  it("should return true from wait", () => {
    expect(MercadoLibre.wait()).toBe(true);
  });

  it("should create img element in paso1", () => {
    document.createElement = jest.fn().mockReturnValue(ark);

    MercadoLibre.paso1();

    expect(document.createElement).toHaveBeenCalledWith("img");
  });

  it("should create img element in gracias when isExceeded is false", () => {
    context = {
      state: {
        isExceeded: false
      }
    };

    document.createElement = jest.fn().mockReturnValue(ark);

    MercadoLibre.gracias(context);

    expect(document.createElement).toHaveBeenCalledWith("img");
  });

  it("should not create img element in gracias when isExceeded is true", () => {
    context = {
      state: {
        isExceeded: true
      }
    };
    document.createElement = jest.fn();

    MercadoLibre.gracias(context);

    expect(document.createElement).not.toHaveBeenCalled();
  });
});
